<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		:class="class"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.6667 9.16667V10.8333H3.33337V9.16667H16.6667Z"
			fill="currentColor"
		/>
		<path
			d="M16.6667 13.3333V15H3.33337V13.3333H16.6667Z"
			fill="currentColor"
		/>
		<path d="M16.6667 5V6.66667H3.33337V5H16.6667Z" fill="currentColor" />
	</svg>
</template>
